export enum EmployeePanelRoutes {
  Dashboard = "",
  Home = "home",
  MyProfile = "profile",
  Calendar = 'calendar',
  Settings = 'settings',
  Shifts = "shifts",
  Submissions = "submissions",
  /** „Meine Verknüpfungen" — the employee's own contact-channel links and per-employer shares (#558). */
  Contacts = "contacts"
}
